// Customers Groups Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get fullGroupsList from backend then update fullGroupsList in vuex store ***** //
export const updateFullGroupsList = async ({ commit }) => {
  try {
    const result = await Axios.get('customer_groups_list')
    let list = result.data.data
    let fullList = []
    list.forEach(g => {
      fullList.push({
        value: g.customer_groups_id,
        text: g.customer_groups_name
      })
    })
    commit('updateFullGroupsList', fullList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Get groupsList from backend then update groupsList in vuex store ***** //
export const updateGroupsList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('customer_groups_index', { params: params })
    commit('updateGroupsList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch group from backend ***** //
export const fetchGroupInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`customer_groups_show/${payload}`)
    commit('fetchGroupInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Add group ***** //
export const addGroup = async (ignored, payload = null) => {
  try {
    await Axios.post('customer_groups_store', payload)
    helpers.ktNotify({
      type: 'success',
      text: 'Added Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}

// ***** Update group info ***** //
export const updateGroupInfo = async (ignored, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  try {
    payload.formData.append('_method', 'PATCH')
    await Axios.post(`customer_groups_update/${payload.id}`, payload.formData)
    helpers.ktNotify({
      type: 'success',
      text: 'Updated Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, update failed')
  }
}

// ***** Delete group ***** //
export const deleteGroup = async (ignored, payload) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    await Axios.delete(`customer_groups_destroy/${payload}`)
    helpers.ktNotify({
      type: 'success',
      text: 'Deleted Successfully'
    })
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, deletion failed')
  }
}
